const FILTERS = {
  heading: "FILTERS",
};

export default FILTERS;
